import React from "react";

export const WebSocketContext = React.createContext(null);
export const ChatContext = React.createContext(null);
export const ProfileContext = React.createContext(null);
